import { render, staticRenderFns } from "./ModalCancelar.vue?vue&type=template&id=606d34f2"
import script from "./ModalCancelar.vue?vue&type=script&lang=ts"
export * from "./ModalCancelar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports